<template>
  <div class="introduce">
    <div class="introduce-content-head">
      <div>基金会简介</div>
      <div><img src="@/assets/line.png" alt="" /></div>
      <div>ABOUT THE FOUNDATION</div>
    </div>
    <div class="introduce-content" v-if="navList.length>0">
      <div class="con" v-html="content"></div>
    </div>
  </div>
</template>
<script>

export default {
  updated() {
    this.navIndex = this.$route.query.index;
    this.title = this.$route.query.title;
    this.curIndex = this.$route.query.curIndex;
    localStorage.setItem("currentIndex", this.navIndex);
  },
  mounted() {
    this.load()
  },
  computed:{
    content(){
      let match = this.navList[this.navList.findIndex(v=>v.type == 0)].contents;
      match = match.replace(/<img/g,'<img style="width:100%;height:auto;max-width:1200px;" ');
      return match
    }
  },
  data() {
    return {
      navList:[],
    };
  },
  methods: {
    /**初试加载数据*/
    load(){
      this.$API.home().then(res=>{
        this.navList = res.result.records
        this.queryFundAgencyById(this.navList[this.navList.findIndex(v=>v.type == 0)].id)
      })
    },
    queryFundAgencyById(id){
            let params = {
              'id': id
            }
        this.$API.queryFundAgencyById(params)
        },

  },
};
</script>
<style scoped lang="scss">
.introduce {
  width: 100%;
  padding: 40px 0 60px 0;
  .introduce-content-head {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    > div:nth-child(1) {
      font-size: 26px;
      font-family: MicrosoftYaHei, MicrosoftYaHei-Bold;
      font-weight: 700;
      color: #333333;
    }
    > div:nth-child(2) {
      margin-top: 12px;
    }
    > div:nth-child(3) {
      font-size: 12px;
      font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;
      font-weight: 400;
      color: #999999;
      margin-top: 14px;
    }
  }
}
.introduce-content {
  width: 1200px;
  margin: 0 auto;
  padding: 40px 0 60px 0;

  .con {
    width: 1200px;
    overflow: hidden;
  }

  .introduce-content-head {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    > div:nth-child(1) {
      font-size: 26px;
      font-family: MicrosoftYaHei, MicrosoftYaHei-Bold;
      font-weight: 700;
      color: #333333;
    }
    > div:nth-child(2) {
      margin-top: 12px;
    }
    > div:nth-child(3) {
      font-size: 12px;
      font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;
      font-weight: 400;
      color: #999999;
      margin-top: 14px;
    }
  }
  .introduce-content-main {
    margin-top: 30px;
    > div:nth-child(1) {
      text-indent: 35px;
      font-size: 15px;
      font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;
      font-weight: 400;
      color: #333333;
      line-height: 30px;
    }
    > div:nth-child(2) {
      text-indent: 35px;
      margin-top: 30px;
      font-size: 15px;
      font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;
      font-weight: 400;
      color: #333333;
      line-height: 30px;
    }
  }
  .introduce-content-foot {
    margin-top: 40px;
    display: flex;
    .foot-right {
      margin-left: 24px;
      > div:nth-child(1) {
        display: flex;
        > div:nth-child(2) {
          margin-left: 24px;
        }
      }
      > div:nth-child(2) {
        display: flex;
        margin-top: 24px;
        > div:nth-child(2) {
          margin-left: 24px;
        }
      }
    }
  }
}
.foot-left {
  img {
    width: 384px;
    height: 404px;
  }
}
.rightimg {
  width: 384px;
  height: 190px;
}
</style>
